module.exports = __webpack_public_path__ + "static/media/car-elite.dc87f216.svg";